import { useEffect, useState } from 'react'
import Card from '@/components/common/Card'
import Button from '@/components/common/Button'
import { supabase } from '@/lib/supabase'

export default function ContactScrimmageModal({ teamName, managerInfo, posting, onClose }) {
  const hasContactInfo = managerInfo.email || managerInfo.phone
  const [contactLogged, setContactLogged] = useState(false)

  // Log the contact when modal opens
  useEffect(() => {
    if (!contactLogged && posting?.id) {
      logContact()
    }
  }, [posting?.id])

  const logContact = async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession()
      
      const response = await fetch(
        `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/log-posting-contact`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(session?.access_token && {
              'Authorization': `Bearer ${session.access_token}`
            }),
            'apikey': import.meta.env.VITE_SUPABASE_ANON_KEY
          },
          body: JSON.stringify({
            postingId: posting.id,
            contactMethod: managerInfo.email ? 'email' : 'phone'
          })
        }
      )

      if (response.ok) {
        setContactLogged(true)
        console.log('[ContactModal] Contact logged successfully')
      }
    } catch (error) {
      // Don't block the UI if contact logging fails
      console.warn('[ContactModal] Failed to log contact:', error)
    }
  }

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    })
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <Card className="max-w-md w-full">
        <div className="mb-4">
          <h2 className="font-heading text-xl font-bold text-brand-charcoal mb-2">
            Contact {teamName}
          </h2>
          <p className="text-sm text-brand-slate">
            {formatDate(posting.date)} • {posting.posting_type === 'available' ? 'Home Ice Available' : 'Seeking Away Game'}
          </p>
        </div>

        {hasContactInfo ? (
          <div className="space-y-4">
            {managerInfo.name && (
              <div>
                <label className="text-sm font-medium text-brand-slate">Scrimmage Coordinator</label>
                <p className="text-brand-charcoal font-medium">{managerInfo.name}</p>
              </div>
            )}

            {managerInfo.email && (
              <div>
                <label className="text-sm font-medium text-brand-slate">Email</label>
                <a
                  href={`mailto:${managerInfo.email}`}
                  className="block text-brand-green hover:underline font-medium"
                >
                  {managerInfo.email}
                </a>
              </div>
            )}

            {managerInfo.phone && (
              <div>
                <label className="text-sm font-medium text-brand-slate">Phone</label>
                <a
                  href={`tel:${managerInfo.phone}`}
                  className="block text-brand-green hover:underline font-medium"
                >
                  {managerInfo.phone}
                </a>
              </div>
            )}

            <div className="pt-4 border-t border-border">
              <p className="text-xs text-brand-slate">
                Contact information is displayed based on the coordinator's preferences. Reach out directly to discuss scrimmage details.
              </p>
            </div>
          </div>
        ) : (
          <div className="py-8 text-center">
            <p className="text-brand-slate mb-2">
              No contact information is currently displayed for this team.
            </p>
            <p className="text-sm text-brand-slate">
              The scrimmage coordinator has chosen not to display their contact details publicly.
            </p>
          </div>
        )}

        <div className="mt-6 flex justify-end">
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </div>
      </Card>
    </div>
  )
}

